export class UnknownCommandError extends Error {
    constructor(public readonly commandType: string) {
        super(`No handler registered for command "${commandType}"`);
        this.name = "UnknownCommandError";
    }
}

export class DuplicateCommandHandlerError extends Error {
    constructor(public readonly commandType: string) {
        super(`A handler is already registered for command "${commandType}"`);
        this.name = "DuplicateCommandHandlerError";
    }
}
